import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Checkup from "../../components/checkup"
import { Link } from "gatsby"
import OtherCaseStudy from "../../components/other-case"
import simay from "../../assets/img/teams/08.jpg"
import yagmur from "../../assets/img/teams/yagmur-pinduk.webp"
import busra from "../../assets/img/teams/busra-pinduk.webp"
import rightArrow from "../../assets/img/right-arrow.png"
import uyguncozumler from "../../assets/img/uyguncozumler.png"
import elipse from "../../assets/img/forecrelipse.png"
import organikTrafik from "../../assets/img/organiktrafikde55buyume.jpg"
import yapayzeka from "../../assets/img/2026yapayzekaarama.jpg"
import iletisimGorsel from "../../assets/img/iletisimegecgorsel.png"

const ReferancesDetail = () => (
  <Layout>
    <SEO
      title="Toyota Turkey SEO Success Story | Flatart"
      description="Discover how we achieved 55% organic traffic growth and visibility across 107,000 organic keywords for Toyota Turkey through our SEO and content strategies."
    />
    <style>{`
    .toyota-cta:hover { background-color: #ea4f6a !important; color: white !important; }
    .toyota-stats-grid {
      display: grid;
      grid-template-columns: 176px 176px;
      gap: 10px;
      margin-left: 10px;
    }
    @media (max-width: 600px) {
      .toyota-stats-grid {
        grid-template-columns: 1fr 1fr;
        margin-left: 0;
      }
    }
    .toyota-stat-box {
      background: #c0e6de;
      border-radius: 10px;
      padding: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;
      min-height: 140px;
    }
    .toyota-stat-box .stat-num {
      font-size: 36px;
      font-weight: 700;
      color: #101010;
      display: block;
      line-height: 1.1;
    }
    .toyota-stat-box .stat-label {
      font-weight: 700;
      margin: 4px 0 0;
      color: #101010;
      font-size: 14px;
    }
    .toyota-stat-box .stat-text {
      font-size: 13px;
      line-height: 1.4;
      color: #101010;
      font-weight: 700;
      margin: 0;
    }
    @media (max-width: 600px) {
      .toyota-stats-grid { margin-left: 0; }
    }
  `}</style>
    <div className="referances-detail py60 container">
      <div className="col-md-6 detail-left">
        <b>SUCCESS STORY</b>
        <h1>Toyota Turkey</h1>
        <p>
          Toyota Turkey represents the Japanese automotive brand&apos;s legacy of quality and sustainability in the Turkish market. With its wide model range, hybrid technologies, and strong dealer network, it is one of the leading players in the industry. Through our collaboration with Flatart, the brand achieved exponential year-on-year growth in its goals of reaching users and increasing visibility in the digital space.
        </p>
        <p>
          We aimed to proactively adapt to the rapidly changing dynamics of the automotive sector — especially AI-based searches. This approach enabled Toyota to both reach users more effectively and prepare for the search trends of the future.
        </p>
        <h2>Challenges</h2>
        <ul style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <li>• Despite its strong position in branded searches, insufficient visibility in high-volume non-brand queries.</li>
          <li>• Content cannibalization occurring between campaign and price-focused pages.</li>
          <li>• Lower visibility and awareness in the commercial vehicle segment compared to competitors.</li>
          <li>• Integration of new pages — such as calculation tools, vehicle finder, and dealer pages — into the site.</li>
          <li>• The need to adapt to a new format during a period when search engines are being reshaped.</li>
        </ul>
      </div>
      <div className="col-md-6 referances-boxs">
        <div className="toyota-stats-grid">
          <div className="toyota-stat-box">
            <span className="stat-num">+%55</span>
            <p className="stat-label">Organic Traffic<br />Increase</p>
          </div>
          <div className="toyota-stat-box">
            <span className="stat-num">+%62</span>
            <p className="stat-label">Organic User<br />Count Increase</p>
          </div>
          <div className="toyota-stat-box">
            <span className="stat-num" style={{ fontSize: 32 }}>107,000+</span>
            <p className="stat-label">Ranked Keywords</p>
          </div>
          <div className="toyota-stat-box" style={{ justifyContent: "center" }}>
            <p className="stat-text">
              Rise to positions 1–3 in &ldquo;commercial&rdquo; segment queries
            </p>
          </div>
        </div>
        <div className="provided">
          <h3>Services Provided</h3>
          <div className="provided-box">
            <div className="box">
              <Link to="/search-engine-optimization/"></Link>
              <svg style={{ marginLeft: -7 }} xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 79 80">
                <g id="Icons-_-Shopping-_-Chart-line_1" data-name="Icons-/-Shopping-/-Chart-line#1" transform="translate(-0.462 0.373)">
                  <rect id="bound" width="79" height="80" transform="translate(0.462 -0.373)" fill="none" />
                  <path id="Path-95" d="M9.6,55.773H59.071a3.3,3.3,0,0,1,0,6.6H6.3a3.3,3.3,0,0,1-3.3-3.3V6.3a3.3,3.3,0,0,1,6.6,0Z" transform="translate(6.895 7.094)" fill="#000000" />
                  <path id="Path-97" d="M12.7,33.493a3.3,3.3,0,0,1-4.812-4.512L20.261,15.788a3.3,3.3,0,0,1,4.547-.253l9.762,8.33L47.289,7.755a3.3,3.3,0,1,1,5.178,4.088l-14.842,18.8a3.3,3.3,0,0,1-4.73.465L22.92,22.6Z" transform="translate(16.088 15.138)" fill="#000000" opacity="0.3" />
                </g>
              </svg>
              SEO
            </div>
          </div>
        </div>
        <div className="project-details">
          <h3>Impressum</h3>
          <div className="project-details_list">
            <ul>
              <li>Brand Strategist:</li>
              <li>SEO:</li>
              <li>Content Writer:</li>
            </ul>
            <ul>
              <li><img src={simay} alt="Simay Akkurt Çetin" />Simay Akkurt Çetin</li>
              <li><img src={yagmur} alt="Yağmur Çiftçi" />Yağmur Çiftçi</li>
              <li><img src={busra} alt="Büşra Kanat" />Büşra Kanat</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div className="container">
      <div className="content-section content row reverse-mobile" style={{ display: "flex", flexWrap: "wrap" }}>
        <div className="col-md-6" style={{ paddingLeft: 0 }}>
          <h2 style={{ fontSize: 28, textAlign: "left", fontWeight: "bold", marginBottom: 20 }}>Solutions Applied</h2>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • New page structures were created aligned with user search intent.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Pages experiencing cannibalization were identified and separated, with optimizations applied to the correct pages.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Metadata and content structures were reorganized to align with search intent and remain up to date.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • All newly launched pages were technically and content-wise optimized before publication.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • External signals supporting brand authority were strengthened through competitor analysis and strategic efforts.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Core Web Vitals optimizations and site speed improvements were carried out.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Content depth, internal linking structure, and technical signals for the commercial vehicle segment were optimized accordingly.
          </p>
          <p style={{ maxWidth: 500, textAlign: "left", marginLeft: 20 }}>
            • Content structure and technical infrastructure were restructured to be citable in AI-based search results.
          </p>
        </div>
        <div className="col-md-6" style={{ position: "relative", minHeight: 400 }}>
          <img
            src={elipse}
            alt=""
            className="d-none d-md-block"
            style={{ position: "absolute", bottom: "6%", right: "-2%", width: "70%", zIndex: 1 }}
          />
          <img
            src={uyguncozumler}
            alt="Toyota Turkey Solutions Applied"
            style={{ position: "relative", width: "100%", zIndex: 2 }}
          />
        </div>
      </div>

      <div className="text-center" style={{ marginTop: 60 }}>
        <h2>55% Organic Traffic Growth and<br />Preparation for the AI Era</h2>
        <img
          style={{ width: "100%", margin: "30px auto" }}
          src={organikTrafik}
          alt="55% Organic Traffic Growth"
        />
        <h2>55% increase in organic traffic<br />achieved through user experience strategies</h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          Page structures focused on search intent and the applied technical improvements brought about sustainable growth in both visibility and traffic.
        </p>
      </div>

      <div className="text-center" style={{ marginTop: 60 }}>
        <h2>Visibility achieved across<br />107,000+ keywords</h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          By increasing our visibility in commercial vehicle, campaign, and price-focused queries, we achieved first-page rankings in highly competitive areas.
        </p>
      </div>

      <div className="text-center" style={{ marginTop: 40 }}>
        <h2>Organic channel&apos;s share of total traffic<br />rose from 45% to 52%</h2>
        <p style={{ fontSize: 18, margin: "20px auto 30px", maxWidth: 900 }}>
          Organic traffic share increased by achieving significant ranking gains for high-volume, high-conversion non-brand keywords focused on campaigns, pricing, and commercial segments.
        </p>
        <p style={{ fontSize: 14, fontStyle: "italic", color: "#666", maxWidth: 900, margin: "0 auto 60px" }}>
          * Results cover year-over-year comparisons (YoY) for the last 12 months — 2024 vs. 2025.
        </p>
      </div>

      <div
        className="content-section content row reverse-mobile"
        style={{ display: "flex", flexWrap: "wrap", marginTop: 60, marginBottom: 60 }}
      >
        <div className="col-md-6" style={{ paddingLeft: 0 }}>
          <h2 style={{ fontSize: 36, textAlign: "left", marginBottom: 20 }}>
            A Toyota Ready for<br />AI Searches in 2026!
          </h2>
          <p style={{ maxWidth: 500, textAlign: "left" }}>
            The AI search visibility preparations initiated in 2025 positioned Toyota Turkey to be visible in next-generation search results as it entered 2026. Content was structured so that AI models could crawl it and cite it as a source in their responses.
          </p>
        </div>
        <div className="col-md-6">
          <img
            src={yapayzeka}
            alt="Toyota Ready for AI Searches in 2026"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>

    <div className="container" style={{ marginBottom: 80 }}>
      <div
        className="content-section content row reverse-mobile"
        style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
      >
        <div className="col-md-6">
          <img
            src={iletisimGorsel}
            alt="Grow with us"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-6" style={{ paddingLeft: 40 }}>
          <h2 style={{ fontSize: 36, marginBottom: 24 }}>
            If you want to grow<br />with us too!
          </h2>
          <Link
            to="/contact/"
            className="red-button toyota-cta"
            style={{ display: "inline-flex", width: "fit-content", padding: "12px 16px" }}
          >
            Get in Touch
            <img alt="right arrow" src={rightArrow} style={{ width: 20, height: 20, objectFit: "contain" }} />
          </Link>
        </div>
      </div>
    </div>

    <OtherCaseStudy />
    <Checkup />
  </Layout>
)

export default ReferancesDetail
